import scrollIt from './scrollit';

document.addEventListener('click', event => {
  if (event.target.matches('.js-btt')) {
    event.preventDefault();
    scrollIt(0, 500, 'easeOutQuad');
  }
});



// WEBPACK FOOTER //
// ./src/js/scroll-to-top.js